jQuery(document).on("swup:pageView", function () {
  $ = jQuery;

  if ($("main.referrals").length) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

    /*****************************************************************
      Value Slider Mobile
    ******************************************************************/
    var valueSlider = $(".value-slider-mobile .owl-carousel");
    valueSlider.owlCarousel({
      autoplay: false,
      loop: true,
      nav: false,
      items: 1,
      margin: 0,
      slideBy: 1,
      dots: true,
      autoHeight: false,
      lazyLoad: true,
      checkVisibility: false,
    });
  }
});
